const PNP_REFRESH_V1 = 'GROW-2792';
const TYPE_DESCRIPTION = '[Type: String][Vis.: high] - ';
const EXPERIMENT_DESCRIPTION = ' - A string in pricing experiment GROW-2792';
const CATEGORY = 'Heading';

const HEADING_COPY = {
  CHOOSE_PLAN: {
    id: 'Pricing.experimentHeadingCopy.ChooseThePlan',
    defaultMessage: 'Choose the plan that works for you',
    desc: {
      id: 'Pricing.experimentHeadingCopy.ChooseThePlan',
      message: `${TYPE_DESCRIPTION} ${CATEGORY} label ${EXPERIMENT_DESCRIPTION}`,
      project: PNP_REFRESH_V1,
    },
  },
};

export default HEADING_COPY;
